import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CropLandscapeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"crop_landscape"}/>
}
